import * as PropertyBucket from '../../Properties/Properties';

export function sendFiles(droppedFiles)
{
	const formData = new FormData();

	if (Array.isArray(droppedFiles))
		droppedFiles.map((file, index) => {
			formData.append(`file${index}`, file.file)
		});
	else
		formData.append('file', droppedFiles.file);

	return fetch(PropertyBucket.fileUpload(), {
		method: 'POST',
		headers: new Headers({
			'Access-Control-Allow-Origin': '*',
			'Authorization': 'Bearer ' + localStorage.getItem('token')
		}),
		body: formData,
		cache: 'no-cache'
	})
}

export function getDocumentFile(fileId)
{
	return fetch(PropertyBucket.documentFileDownload(fileId), {
		method: 'GET',
		headers: new Headers({
			'Authorization': 'Bearer ' + localStorage.getItem('token')
		})
	})
}

export function getControlListXLSXFile(controlStatus, sortBy, sortOrder)
{	
	let params = `?controlStatus=${controlStatus}`;
	if (sortBy && sortOrder) {
		params += `&sortBy=${sortBy}&sortOrder=${sortOrder}`;
	} else {
		params += "&sortBy=controlStatusChangeDate&sortOrder=asc";
	}
	return fetch(PropertyBucket.controlsListXSDownload() + params, {
		method: 'GET',
		responseType: 'arraybuffer',
		headers: new Headers({
			'Authorization': 'Bearer ' + localStorage.getItem('token'),
			'Content-Type': 'blob'
		})
	})
}
